<template>
	<db-col width="120" height="60" valign="middle" class="switch-wrapper" :class="'switch-wrapper-' + !!value" @click="clickHandler">
		<db-col class="switch-pointer" width="44" height="44" :class="'switch-pointer-' + !!value"></db-col>
	</db-col>
</template>

<script>
	export default {
		name: 'switch_',
		
		props: {
			height: {
				type: [String, Number],
				default: '88'
			},
			
			value: {
				type: [Boolean, String, Number],
				default: false
			}
		},
		
		methods: {
			clickHandler(){
				this.$emit('input', !this.value)
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	.switch-wrapper{
		position: relative;
		//padding: 0 2px;
		background: #eee;
		border-radius: 200px;
		
		&.switch-wrapper-true{
			background: rgba(#3B9FFF, .2);
		}
		
		.switch-pointer{
			border-radius: 200px;
			background: #bababa;
			transition: all .3s;
			margin-left: 10px;
			transform: translateX(0);
			
			&.switch-pointer-true{
				background: #3B9FFF;
				transform: translateX(100%);
				margin-left: 20px;
			}
		}
	}
</style>
